import ORCIDLoginButton from "../ORCIDLoginButton/ORCIDLoginButton.js";
import styles from "../../pages/UserDashboard/UserDashboard.module.css";

const SignInPage = () => (
  <main className={styles["stats-page"]}>
    <h1>Lifetime Statistics</h1>
    <p>Sign in to view your personal statistics.</p>
    <ORCIDLoginButton />
  </main>
);

export default SignInPage;
